
import { useQuery } from "@tanstack/react-query";
import { mockBlogPosts } from "@/data/mockBlogPosts";

export function useBlogPost(slug: string | undefined) {
  const { data: post, isLoading, error } = useQuery({
    queryKey: ['blog-post', slug],
    queryFn: async () => {
      if (!slug) return null;
      
      // In a real app, fetch from an API
      // return await fetch(`/api/blog-posts/${slug}`).then(res => res.json());
      
      // For now, return mock data with a delay to simulate API call
      await new Promise(resolve => setTimeout(resolve, 300));
      return mockBlogPosts.find(post => post.slug === slug) || null;
    },
    enabled: !!slug,
  });
  
  return {
    post,
    isLoading,
    error,
  };
}
